/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";
import { NavLink } from "react-router-dom";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { Text } from "UpduoLibrary";
import {
  skaleDeactiveGray,
  skaleLinkBlue,
  upduoPrimaryDark,
} from "config/UpduoColors";

import * as UpduoAnalytics from "config/UpduoAnalytics";

interface BreadcrumbLevelProps {
  grouping: string | null;
  groupingObject: {
    id?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
  } | null;
  isFirst: boolean;
  isLast: boolean;
  url: string;
}

export default function BreadcrumbLabel({
  grouping,
  groupingObject,
  isFirst,
  isLast,
  url,
}: BreadcrumbLevelProps) {
  const selfObject = useSelector((state: RootState) => state.selfObject);
  const [isHovering, setIsHovering] = useState(false);

  const organizationName = selfObject.organizationName;
  const organizationId = selfObject.organizationId;

  const _handleClickCheck = (e) => {
    if (grouping === "employee") {
      e.preventDefault();
    }
    if (grouping !== null) {
      UpduoAnalytics.logEvent(`user-managerdashboard-breadcrumb`, {
        locationType: grouping,
        locationId: groupingObject?.id,
        locationName: groupingObject ? groupingObject["name"] : undefined,
      });
    } else {
      UpduoAnalytics.logEvent(`user-managerdashboard-breadcrumb`, {
        locationType: "organization",
        locationId: organizationId,
        locationName: organizationName,
      });
    }
  };

  const _handleGenerateLink = () => {
    if (groupingObject?.id) {
      return `/${url}/${grouping}/${groupingObject.id}`;
    } else {
      return `/${url}/`;
    }
  };

  let shownText: string | undefined = organizationName;
  if (groupingObject) {
    if (groupingObject.name) {
      shownText = groupingObject.name;
    } else {
      shownText = `${groupingObject.firstName} ${groupingObject.lastName}`;
    }
  }
  return (
    <NavLink
      to={_handleGenerateLink()}
      onClick={(e) => _handleClickCheck(e)}
      style={{
        marginLeft: isFirst ? -5 : 0,
        textDecoration: "none",
      }}
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}
    >
      <View
        style={{
          flex: 0,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Text
          style={{
            fontSize: 12,
            color: skaleDeactiveGray,
          }}
        >
          {isFirst ? " " : "  /  "}
        </Text>
        <View>
          <Text
            style={{
              color: isHovering
                ? skaleLinkBlue
                : isLast
                ? upduoPrimaryDark
                : skaleDeactiveGray,
            }}
          >
            {shownText}
          </Text>
        </View>
      </View>
    </NavLink>
  );
}
